import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_CASES_QUERY = graphql(/* GraphQL */ `
  query ContractDemandCases($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        id
        status
        demandRequest {
          id
          lineItems {
            id
            qualifiedSuppliers
          }
        }
        sourcingCases {
          id
          status
          cancellationReason
          cancellationReasonText
          createdAt
          updatedAt
          sequenceNumber
          supplier {
            id
            name
            supplierId
            contact {
              id
              firstName
              lastName
              email
              internalId
            }
          }
          quote {
            id
            currency
            totalValue
            totalDiscountedValue
            discount
          }
          issues {
            id
            status
            variant
          }
          latestComment {
            id
            message
            authorId
            createdAt
          }
        }
      }
    }
  }
`);

export const CONTRACT_DEMAND_ADD_CASES_MUTATION = graphql(/* GraphQL */ `
  mutation ContractDemandAddCases($id: UUID!, $data: TsrctContractDemandAddSourcingCasesInput!) {
    tesseract {
      contractDemand(id: $id) {
        addSourcingCases(data: $data) {
          id
          sequenceNumber
          createdAt
          updatedAt
          status
          supplier {
            id
            name
            supplierId
            contact {
              id
              firstName
              lastName
              email
              internalId
            }
          }
          quote {
            id
            currency
            totalValue
            totalDiscountedValue
            discount
          }
          issues {
            id
            status
            variant
          }
        }
      }
    }
  }
`);

export const RELEASE_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation ReleaseSourcingCase($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        release
      }
    }
  }
`);
